import React, { useEffect, useState } from 'react'
import { Button, Table, Space, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTab } from '../../custom-hooks/useTab';
import { useStore } from '../../store';
import backBtn from "../../assets/images/back-arrow.svg";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import editIcon from "../../assets/images/editIcon.svg";
import { deleteRequest } from '../../api/http';
import userServiceApi from '../../api/userServiceApi';
import { toast } from 'react-toastify';

export default function Sponsors() {
    const navigate = useNavigate();
    const { sponsors } = useStore();
    const { getSponsorList } = useTab();

    console.log("sponsors", sponsors)

    sessionStorage.setItem("page", "sponsors")

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const deleteSponsorHandler = async (id) => {
        const headers = {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        };
        // console.log("id", id)
        try {
            const res = await deleteRequest(userServiceApi.deleteSupporterLogo(id), headers);
            if (res) {
                toast.success("Sponsor deleted successfully");
                getSponsorList();
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        if (sponsors.length == 0) {
            getSponsorList();
        }
    }, [])

    const columns = [
        {
            title: "Logo",
            dataIndex: "mediaLink",
            key: "mediaLink",
            className: "logo",
            width: 150,
            render: (r) => {
                return (
                    r.url && (
                        <img src={`${r.url}`} className="image-logo" />
                    )
                )
            }
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            width: 600
        },
        {
            title: "Sponsor Link",
            dataIndex: "urlLink",
            key: "urlLink",
            render: (t, r) => {
                console.log('r', r)
                return <Space>
                    <span style={{
                        fontSize: "17px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "800px",
                        whiteSpace: "nowrap",
                        display: "inline-block"
                    }}>
                        {r?.urlLink}
                    </span>
                </Space>
            }
        },
        {
            title: " ",
            dataIndex: "",
            key: "",
            className: "sponsors-actions",
            render: (row) => (
                <div>
                    {/* {console.log("row", row)} */}
                    <Space size="middle">
                        <div
                            className="icon-style"
                            onClick={() => deleteSponsorHandler(row.id)}
                        >
                            <img src={deleteIcon} alt="Delete" />
                        </div>
                        {/* <Divider type='vertical' /> */}
                        <div
                            className="icon-style"
                            onClick={() => navigate('/edit-sponsors', { state: { data: row, page: "editsponsors" } })}
                        >
                            <img src={editIcon} alt="Edit" />
                        </div>
                    </Space>
                    {/* ) : ""} */}
                </div>
            )
        }
    ]

    return (
        <div className="tabContainer">
            <div className="main-container" style={{ paddingTop: "5px" }}>
                <div className="header-container">
                    <div className="backbtn-container">
                        <img src={backBtn} onClick={() => navigate('/partner-org')} alt="" />
                        <p>Sponsors</p>
                    </div>
                    <div className="btns">
                        <div className="pending-btn">
                            <Button
                                className="pending-badge"
                                onClick={() => navigate('/add-sponsors', { state: { data: "", page: "addsponsors" } })}
                            >
                                Add Sponsor
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="table-container">
                    <Table
                        rowClassName={() => "rowClassName1"}
                        columns={columns}
                        dataSource={sponsors}
                        // pagination={{
                        //     position: ["none", "none"],
                        // }}
                        pagination={false}
                    />
                </div>
            </div>
        </div>
    )
}
